<template>
    <div class="error">
        error
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods: {

    },
}
</script>

<style scoped lang="scss">
.error {
    width: 100%;
    height: 100%;
}
</style>